export default {
  name: 'UserRightsInfo'
}
